import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["game-button", _ctx.extraClasses])
  }, [
    _createElementVNode("span", null, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    (_ctx.alternative.length && _ctx.isUserOnDesktop)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["game-button__alternative", { noitalic: _ctx.alternative === '↓' || _ctx.alternative === '↑' }])
        }, _toDisplayString(_ctx.alternative), 3))
      : _createCommentVNode("", true)
  ], 2))
}